// extracted by mini-css-extract-plugin
module.exports = {"editor":"Notes_editor__1glQI"};